import { Navigate } from 'react-router-dom';
import Report from '@/pages/Report';
import Contacts from '@/pages/Contacts';
import History from '@/pages/History';
import Profile from '@/pages/Profile';
import Sessions from '@/pages/Sessions';
import Settings from '@/pages/Settings';
import Widgets from '@/pages/Widgets';

import { PATHS } from '@/constants';

export default {
    private: [
        {
            path: PATHS.index,
            element: <Navigate to={PATHS.dashboard} />
        },
        {
            path: `${PATHS.profile.root}/:tab?`,
            element: <Profile />
        },
        {
            path: PATHS.contacts,
            element: <Contacts />
        },
        {
            path: PATHS.sessions,
            element: <Sessions />
        },
        {
            path: PATHS.history,
            element: <History />
        },
        {
            path: PATHS.dashboard,
            element: <Report />
        },
        {
            path: PATHS.settings,
            element: <Settings />
        },
        {
            path: PATHS.widgets,
            element: <Widgets />
        }
    ],
    public: []
};
